import React from 'react';

import Button from '@material-ui/core/Button';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { getItemValue } from '../../helpers';

export default function Component({ children, ...props }) {
  function getSortIcon() {
    if (props.config.id === props.id) {
      return props.config.asc ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />;
    }
    return <></>;
  }

  function getSort(event) {
    event.preventDefault();

    if (props.config.id !== props.id) {
      props.config.asc = true;
    }

    props.setConfig({
      ...props.config,
      asc: !props.config.asc,
      id: props.id,
      keys: props.keys ? props.keys : props.config.keys,
    });

    const data = [...props.state.data];
    const collator = new Intl.Collator('pt-br', { numeric: true, sensitivity: 'base' });
    data.sort((a, b) => {
      for (const key of props.keys) {
        const A = getItemValue(a, key);
        const B = getItemValue(b, key);
        console.log({ A, B });
        // const r = (props.config.asc ? collator.compare(a[key], b[key]) : collator.compare(b[key], a[key]));
        // console.log({ A, B });
        const r = props.config.asc ? collator.compare(A, B) : collator.compare(B, A);
        if (r) {
          return r;
        }
      }
      return 0;
    });
    props.setState({ ...props.state, data: data });
  }

  return (
    <Button color="primary" onClick={getSort}>
      {children} {getSortIcon()}
    </Button>
  );
}
